import React from 'react';
import { useTranslation } from 'react-i18next';
import { IssueType } from '@momentum/types';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/ui/Dialog';
import { ViewGoalContent } from './ViewGoalContent.js';
import type { FullIssueWithChildren } from '@/shared/utils/issue-guards';

interface ViewGoalDialogProps {
  goal: FullIssueWithChildren;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  currentEmployeeId?: string;
}

export const ViewGoalDialog: React.FC<ViewGoalDialogProps> = ({
  goal,
  open,
  onOpenChange,
  currentEmployeeId,
}) => {
  const { t } = useTranslation('goals');

  const title =
    goal.type === IssueType.TASK ? t('viewTaskTitle') : t('viewGoalTitle');

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size="lg" className="flex flex-col max-h-[90vh] p-0">
        <DialogHeader className="px-6 pt-6 pb-4 border-b border-border shrink-0">
          <DialogTitle className="text-xl font-bold">{title}</DialogTitle>
        </DialogHeader>
        <div className="flex-1 min-h-0 overflow-y-auto">
          <ViewGoalContent goal={goal} currentEmployeeId={currentEmployeeId} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
